import { Select } from "antd";
import "./style.scss";
import PropTypes from "prop-types";

export default function DropDown({
  config,
  handleChange,
  selectedValue,
  showSearchBar,
  blackText,
}) {
  DropDown.propTypes = {
    config: PropTypes.object,
    handleChange: PropTypes.func,
    selectedValue: PropTypes.string,
    showSearchBar: PropTypes.bool,
    blackText: PropTypes.bool,
  };

  return (
    <div className="dropdown">
      <Select
        placeholder={config?.placeholder}
        label={config?.label}
        name={config?.name}
        className={`${
          blackText ? "dropDownSelectBlackText" : "dropDownSelect"
        } font-face-regular ${config?.class} ${
          showSearchBar ? "black-placeholder" : "white-placeholder"
        }`}
        options={config?.options}
        onChange={handleChange}
        value={selectedValue}
        placement="bottomRight"
      />
    </div>
  );
}
